import React from "react";
import { Layout } from "@/components/Layout";
import { InquiryForm } from "@/components/InquiryForm";
import { UNIT_TYPES } from "@/lib/constants";

const fields = [
  { key: "name", label: "Your Name", required: true, placeholder: "Full name" },
  { key: "email", label: "Email Address", required: true, type: "email", placeholder: "you@email.com" },
  { key: "phone", label: "Phone Number", type: "tel", placeholder: "(000) 000-0000" },
  { key: "unit_type", label: "Type of Electric Mobile Unit", required: true, type: "select", options: UNIT_TYPES },
  { key: "intended_use", label: "Intended Use", placeholder: "e.g. rental fleet, personal, resale, off-road" },
  { key: "quantity", label: "Quantity (optional)", placeholder: "How many units?" },
  { key: "budget", label: "Target Budget (optional)", placeholder: "e.g. $1,500 per unit" },
  { key: "message", label: "Describe What You Need", required: true, type: "textarea", rows: 6, placeholder: "Tell us about the customized or unlisted electric unit you're looking for — specs, colors, features, timeline, or anything else that helps us help you." },
];

export default function SpecialRequests() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#8CE63C]">Can't Find It? Build It.</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white uppercase tracking-tight mt-4">Special Requests</h1>
        <p className="text-[#9EABA0] text-sm sm:text-base leading-relaxed mt-4">
          Looking for a type of electric mobile unit that isn't listed, or need a customized unit? Tell us what you have in mind and our team will follow up with options, specifications, and pricing. Customization is available.
        </p>
        <div className="mt-8">
          <InquiryForm
            type="Special Request"
            testIdPrefix="special-request"
            fields={fields}
            submitLabel="Submit Special Request"
            thankYou={{
              title: "Request Received!",
              body: "Thanks for reaching out. Our team will review your custom request and get back to you with options and pricing shortly.",
            }}
          />
        </div>
      </div>
    </Layout>
  );
}
